import type { Language } from "../i18n";
import { SUPPORTED_LANGUAGES, t } from "../i18n";

export interface LanguageSwitchProps {
  language: Language;
  onChange: (language: Language) => void;
}

export function LanguageSwitch({ language, onChange }: LanguageSwitchProps) {
  return (
    <div
      className="language-switch"
      role="group"
      aria-label={t(language, "language_switch_aria")}
      data-testid="language-switch"
    >
      {SUPPORTED_LANGUAGES.map((lang) => {
        const isActive = language === lang;
        return (
          <button
            key={lang}
            type="button"
            className={`language-switch__btn ${isActive ? "language-switch__btn--active" : ""}`}
            onClick={() => onChange(lang)}
            aria-pressed={isActive}
            aria-label={lang.toUpperCase()}
            data-testid={`lang-btn-${lang}`}
          >
            {lang.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
